import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { colors } from "../../common/colors";

interface OptionsModalProps {
  open: boolean;
  message?:string;
  nextText?:string;
  closeText?:string;
  onClose: () => void;
  onNext: () => void;
}

const PersonalInfoPopup: React.FC<OptionsModalProps> = ({
  open,
  message,
  nextText,
  closeText,
  onClose,
  onNext,
}) => {
  return (
    <Modal
      style={{ zIndex: 9999 }}
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={style}>
        <img
          alt=""
          style={{ width: 100 }}
          src={require("../../assets/images/logo.png")}
        />
        <br />
        <Typography>
        {message}
        </Typography>
        <br />
        <Button onClick={() => onNext()} sx={buttonStyle}>
         {nextText}
        </Button>
      </Box>
    </Modal>
  );
};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const buttonStyle = {
  color: colors.farm_blue200,
  fontWeight: "600",
};

export default PersonalInfoPopup;
